export default "__VITE_ASSET__Cmqv3VhV__"